import { apiCall, API_CONFIG } from './api';

export const reportsAPI = {
  getDailySaleReport: async ({
    filterType = 'today',
    date,
    month,
    year,
    startDate,
    endDate,
    productId,
    productNumericId,
  } = {}) => {
    try {
      const queryParams = new URLSearchParams();
      if (filterType) queryParams.set('filterType', filterType);
      if (date) queryParams.set('date', date);
      if (month) queryParams.set('month', month);
      if (year) queryParams.set('year', year);
      if (startDate) queryParams.set('startDate', startDate);
      if (endDate) queryParams.set('endDate', endDate);
      if (productId) queryParams.set('productId', productId);
      if (productNumericId != null && productNumericId !== '') {
        queryParams.set('productNumericId', String(productNumericId));
      }

      const response = await apiCall(
        `${API_CONFIG.ENDPOINTS.REPORTS_DAILY_SALE}?${queryParams.toString()}`,
        { method: 'GET' }
      );

      if (response.success) {
        return {
          success: true,
          data: response.data?.products || [],
          summary: response.data?.summary || { totalQty: 0, totalAmount: 0, productCount: 0 },
          dailyBreakdown: response.data?.dailyBreakdown || [],
          msg: response.msg,
        };
      }

      return {
        success: false,
        error: response.message || response.msg || 'Failed to fetch daily sale report',
      };
    } catch (error) {
      console.error('Daily sale report error:', error);
      return {
        success: false,
        error: 'Network error. Please try again.',
      };
    }
  },
};
